a<template>
    <div class="artcleMain">
        <p class="current">当前位置：<span>{{ currentName }}</span></p>
        <div class="artcle-box">
            <div class="menu infoNav4" style="margin-right: 10px;">
                <ul style=" padding: 0 0;">
                    <li class="slotPoper" @click="ClickArry()" :class="active == '-1'?'slotPoperColor':''">全部</li>
                    <li class="slotPoper"  @click="handleListarticle(item,index)"
                        :class="index == active ? 'slotPoperColor' : ''"
                        v-for="item,index in maintypeData" :key="item.cate_id" >{{ item.cate_name }}</li>
                </ul>
               


            </div>

           
            <expertList :type="1" :cateId="cateId" :channelType="channelType"></expertList>
          
        </div>
    </div>
</template>

<script>
import expertList from './expertList.vue'
export default({
    data(){
        return{
            cate_values: ['industry','special','field','supply','company'],
            maintypeData:[],
            currentName: '',
            cateId: '',
            widthNew: false,
            active: '-1',
            channelType: ''
        }
    },
    components: {
        expertList
    },
    methods:{
         //   获取专家类型菜单
        getMenuList(){
            const data = {
                pageNum: 1,
                pageSize: 99999,
                cate_values: this.cate_values,
                // parent_cate_value: 'expert'
            }
            this.$store.dispatch('menu/menuList', data)
                .then((res) => {
                    console.log(res);
                    this.maintypeData = []
                    if(res.ok){
                        const list = res.data.items
                        if(list.length != 0){
                            this.maintypeData = list
                        }
                        
                    }
                    if(sessionStorage.getItem('lawId')){
                        let ids = JSON.parse(sessionStorage.getItem('lawId'))
                        for (let i = 0; i < this.maintypeData.length; i++) {
                           for (let y = 0; y < ids.length; y++) {
                                if(ids[y] == this.maintypeData[i].cate_id){
                                    this.active = i
                                    this.cateId = this.maintypeData[i].cate_id
                                    this.channelType = this.maintypeData[i].channel
                                    return
                                }
                           }
                            
                        }
                     
                       
                    }
                
                })
                .catch((err) => {
                    
                    console.log(err);
                }) 
        },
     
        handleListarticle(value,index){
            console.log(value);
            this.active = index
            this.cateId = value.cate_id
            this.channelType = value.channel
            console.log(this.channelType);
          
           
        },
        ClickArry(){
            this.active = 1
            this.cateId = ''
            this.channelType = ''
        }

       
    },
    mounted(){
        
        this.currentName = sessionStorage.getItem("name")
    },
    
    created(){
        
        this.getMenuList()
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
       
    }
})
</script>
<style scoped lang="scss">
@import url(../../css/channelPolicy.css);

.slotPoperColor{
    color: #00a8a8;
    border-bottom: 1px solid #00a8a8;
}
.infoNav4{
    ul li{
        line-height: 50px;
        cursor: pointer;
    }
    ul li:hover{
        color: #00a8a8;
    }
}
</style>

